import { HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { AuthService } from "../services/auth.service";
import { inject } from "@angular/core";
import { environment } from "@environments/environment";

export function httpAuthInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
	const authService = inject(AuthService);

	// We need to use environment.httpInterceptor.allowedList array to check if the request url matches any of the allowed urls
	// If so, we add the auth bearer token to the request headers
	const allowedList = environment.httpInterceptor.allowedList;
	const isAllowed = allowedList.some(urlPattern => {
		// Convert wildcard patterns to regex
		const regexPattern = urlPattern.replace(/\*/g, ".*");
		const regex = new RegExp(`^${regexPattern}$`);
		return regex.test(req.url);
	});

	if (isAllowed) {
		if (!authService.userTokens || typeof authService.userTokens !== "function") return next(req);
		const clonedReq = req.clone({
			setHeaders: {
				Authorization: `Bearer ${authService?.userTokens().accessToken}`
			}
		});
		return next(clonedReq);
	}

	return next(req);
}
